/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientSurveyModel } from '../../models/client-survey-model';

export interface GetSurvey$Json$Params {

/**
 * survey id filter
 */
  surveyId: number;
}

export function getSurvey$Json(http: HttpClient, rootUrl: string, params: GetSurvey$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyModel>> {
  const rb = new RequestBuilder(rootUrl, getSurvey$Json.PATH, 'get');
  if (params) {
    rb.path('surveyId', params.surveyId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientSurveyModel>;
    })
  );
}

getSurvey$Json.PATH = '/api/Survey/{surveyId}';
